export default __webpack_public_path__ + "static/media/woocommerce.32bf323a.svg";